module.exports = __webpack_public_path__ + "static/media/image1.e32c7f50.jpeg";